if (!customElements.get('quote-carousel')) {
  customElements.define(
    'quote-carousel',
    class QuoteCarousel extends HTMLElement {
      constructor() {
        super();
      }

      setNewInterval() {
        this.intervalId = setInterval(() => {
          if (this.currentIndex < this.logos.length - 1) {
            this.currentIndex = this.currentIndex + 1;
          } else {
            this.currentIndex = 0;
          }

          this.logos.forEach((image, i) => {
            if (i == this.currentIndex) {
              image.classList.remove('opacity-15');
            } else {
              image.classList.add('opacity-15');
            }
          })

          if (this.quotes[this.currentIndex]) {
            this.quotes.forEach((quote, i) => {
              if (i == this.currentIndex) {
                quote.classList.remove('opacity-0');
              } else {
                quote.classList.add('opacity-0');
              }
            })
          }

          if (this.images[this.currentIndex]) {
            this.images.forEach((image, i) => {
              if (i == this.currentIndex) {
                image.classList.remove('opacity-0');
              } else {
                image.classList.add('opacity-0');
              }
            })
          }
        }, 5000);
      }

      handleLoad() {
        this.setNewInterval();
      }

      handleClick(event) {
        this.currentIndex = Number(event.currentTarget.dataset.index);
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.setNewInterval();
        }

        this.logos.forEach((image, i) => {
          if (i == Number(event.currentTarget.dataset.index)) {
            image.classList.remove('opacity-15');
          } else {
            image.classList.add('opacity-15');
          }
        })

        if (this.quotes[Number(event.currentTarget.dataset.index)]) {
          this.quotes.forEach((quote, i) => {
            if (i == Number(event.currentTarget.dataset.index)) {
              quote.classList.remove('opacity-0');
            } else {
              quote.classList.add('opacity-0');
            }
          })
        }

        if (this.images[Number(event.currentTarget.dataset.index)]) {
          this.images.forEach((image, i) => {
            if (i == Number(event.currentTarget.dataset.index)) {
              image.classList.remove('opacity-0');
            } else {
              image.classList.add('opacity-0');
            }
          })
        }
      }

      connectedCallback() {
        this.images = this.querySelectorAll('.quote-carousel__image');
        this.quotes = this.querySelectorAll('.quote-carousel__quote');
        this.logos = this.querySelectorAll('.quote-carousel__logo');
        this.currentIndex = 0;
        this.intervalId = null;
        
        document.addEventListener('DOMContentLoaded', this.handleLoad.bind(this));
        this.logos.forEach(logo => logo.addEventListener('click', this.handleClick.bind(this)));
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.handleLoad.bind(this));
        this.logos.forEach(logo => logo.removeEventListener('click', this.handleClick.bind(this)));
      }
    }
  );
}
